module.exports = __webpack_public_path__ + "img/berget-logo-bottom3.6808e252.png";